import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { YMaps, Map, Placemark } from "@pbe/react-yandex-maps";
import { useTranslation } from "react-i18next";

type Props = {
  open: boolean;
  onClose: () => void;
  latitude?: string | number | null;
  longitude?: string | number | null;
  title?: string;
  address?: string;
};

// Shows a single washing-center location on a Yandex map inside a modal.
// Opened from the "Location" pin in the RM washing-centers table.
const LocationMapModal = ({
  open,
  onClose,
  latitude,
  longitude,
  title,
  address,
}: Props) => {
  const { t } = useTranslation();
  const lat = latitude != null ? parseFloat(String(latitude)) : NaN;
  const lon = longitude != null ? parseFloat(String(longitude)) : NaN;
  const hasCoords = !isNaN(lat) && !isNaN(lon);
  const center: [number, number] = hasCoords ? [lat, lon] : [40.4093, 49.8671]; // Baku fallback

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pr: 6 }}>
        {title || t("forms.carWash.stepLocation")}
        {address && (
          <Typography variant="body2" color="text.secondary">
            {address}
          </Typography>
        )}
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        {hasCoords ? (
          <Box sx={{ height: 400, width: "100%" }}>
            <YMaps query={{ apikey: process.env.REACT_APP_YANDEX_MAP_API_KEY }}>
              <Map
                defaultState={{ center, zoom: 16 }}
                width="100%"
                height="100%"
              >
                <Placemark geometry={center} />
              </Map>
            </YMaps>
          </Box>
        ) : (
          <Box sx={{ p: 4, textAlign: "center" }}>
            <Typography color="text.secondary">
              {t("manageCarWashes.noCoordinates")}
            </Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default LocationMapModal;
